import { useEffect, useState } from "react";

/*
 * Appearance: follow the system (default), or force dark or light. Stored per
 * browser in localStorage; index.html applies it before first paint so there
 * is no flash, and the stylesheet keys off <html data-theme>.
 */
export type Theme = "system" | "dark" | "light";
const KEY = "pm_theme";

export function readTheme(): Theme {
  try { const t = localStorage.getItem(KEY); return t === "dark" || t === "light" ? t : "system"; } catch { return "system"; }
}

export function applyTheme(t: Theme) {
  try { if (t === "system") localStorage.removeItem(KEY); else localStorage.setItem(KEY, t); } catch { /* private window */ }
  if (t === "system") delete document.documentElement.dataset.theme; else document.documentElement.dataset.theme = t;
}

export function useTheme(): [Theme, (t: Theme) => void] {
  const [t, setT] = useState<Theme>(readTheme);
  useEffect(() => { applyTheme(t); }, [t]);
  return [t, setT];
}
